export const translations = {
  en: {
    appName: 'Ktebstan',
    genres: 'Genres',
    publisher: 'Publisher',
    language: 'Language',
    pages: 'Pages',
    publicationYear: 'Publication Year',
    isbn: 'ISBN',
    type: 'Type',
    tags: 'Tags',
    of: 'of',
    close: 'Close',
    videoPreview: 'Video Preview',
    embeddedContent: 'Embedded Content',
    relatedBooks: 'Related Books',
    noRelatedBooks: 'No related books',
    ratings: 'ratings',
    rateThisBook: 'Rate this book',
    ratingSubmitted: 'Rating submitted successfully',
    ratingSubmissionError: 'Rating could not be added',
    views: 'views',
    downloads: 'downloads',
    likes: 'likes',
    readPdf: 'Read',
    listenBook: 'Listen',
    chapter: 'Chapter',
    download: 'Download',
    buyNow: 'Buy Now',
    bookNotFound: 'Book not found',
    description: 'Description',
    author: 'Author',
    category: 'Category',
    subtitle: 'Subtitle',
    reviews: 'Reviews',
    review: 'Review',
    writeReview: 'Write a review',
    submitReview: 'Submit Review',
    reviewSubmitted: 'Review submitted successfully',
    reviewRequired: 'Review is required',
    reviewSubmissionError: 'Review could not be added',
    rating: 'Rating',
    alreadyRated: 'You have already rated this book',
    clickToRate: 'Click to rate this book',
    loginRequired: 'Please login to submit a review',
    reviewer: 'Reviewer',
    comment: 'Comment',
    createdAt: 'Created At',
    noReviews: 'No reviews yet',
    noBiography: 'No biography available',
    noDateOfBirth: 'No date of birth available',
    join: 'Join',
    signin: 'Sign In',
    menuLanguage: 'English',
    menuBrowse: 'Browse',
    menuProfile: 'Profile',
    menuAuthors: 'Authors',
    menuMyBooks: 'My Books',
    menuSettings: 'Settings',
    menuSignOut: 'Sign Out',
    searchBooks: 'Search books',
    searchAuthors: 'Search authors',
    noBooksAvailable: 'No books available',
    followAuthor: 'Follow Author',
    latestBooks: 'Latest Books',
    noAuthorsAvailable: 'No authors available',
    book: 'book',
    books: 'books',
    moreBooks: 'more books',
    signinWithGoogle: 'Sign in with Google',
    email: 'Email Address',
    password: 'Password',
    createAnAccount: 'Create an account',
    alreadyHaveAnAccount: 'Already have an account?',
    signupWithGoogle: 'Sign up with Google',
    name: 'Name',
    confirmPassword: 'Confirm Password',
    newToKtebstan: 'New to Ktebstan?',
    bookStatistics: 'Book Statistics',
    totalBooks: 'Total Books',
    byDownloads: 'By Downloads',
    byViews: 'By Views',
    byTitle: 'By Title',
    byLikes: 'By Likes',
    sort: 'Sort',
    pdfNotAvailable: 'PDF not available',
    bookAudioFileNotAvailable: 'Book audio file not available',
    allRightsReserved: 'All rights reserved',
    contactUs: 'Contact Us',
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    notice: 'Ktebstan does not digitize any books itself. All books and documents in this library have either been provided directly by their owners or have been digitized by other individuals and organizations. If you find a book PDF file which should not be available, please contact us. Thank you for your understanding.',
    page: 'Page',
    next: 'Next',
    previous: 'Previous',
    speed: 'Speed',
    cancel: 'Cancel',
    submit: 'Submit',
    friends: 'Friends',
    noFriends: 'No friends',
    recentActivity: 'Recent Activity',
    noRecentActivity: 'No recent activity',
    followers: 'Followers',
    avgRating: 'Average Rating',
    booksRead: 'Books Read',
    booksWishlist: 'Books Wishlist',
    joined: 'Joined',
    location: 'Location',
    userNotFound: 'User not found',
    loading: 'Loading...',
    noSocialLinks: 'No social links',
    underConstruction: 'Under Construction',
    profileUpdateSuccess: "Profile updated successfully",
    profileUpdateError: "Failed to update profile",
    unauthorized: "You must be logged in to view this page",
    uploadPhoto: "Upload Photo",
    phone: "Phone",
    saving: "Saving...",
    saveChanges: "Save Changes",
    editProfile: "Edit Profile",
    addFriend: "Add Friend",
    friendRequestSent: "Friend Request Sent",
    following: "Following",
    follow: "Follow",
    message: "Message",
    friendRequest: "Friend Request",
    paidBookAudioMessage: "This book is not available for free audio. Please purchase it to listen to the audio."
  },
  ku: {
    appName: 'کتێبستان',
    genres: 'بەشەکان',
    publisher: 'بڵاوکەرەوە',
    language: 'زمان',
    pages: 'ژمارەی لاپەڕەکان',
    publicationYear: 'ساڵی بڵاوکردنەوە',
    isbn: 'ISBN',
    type: 'جۆر',
    tags: 'تاگەکان',
    of: 'لە',
    close: 'داخستن',
    videoPreview: 'پێشبینینی ڤیدیۆ',
    embeddedContent: 'ناوەڕۆکی تێهەڵکێشکراو',
    relatedBooks: 'کتێبە هاوشێوەکان',
    noRelatedBooks: 'هیچ کتێبە هاوشێوەکان نەدۆزراوە',
    ratings: 'هەڵسەنگاندن',
    rateThisBook: 'ئەم کتێبە هەڵبسەنگێنە',
    ratingSubmitted: 'هەڵسەنگاندنەکەت زیادکرا',
    ratingSubmissionError: 'هەڵسەنگاندنەکەت نەنێردرا. تکایە دووبارە هەوڵ بدەرەوە',
    alreadyRated: 'ئەو کتێبەت هەڵسەنگاندووە',
    clickToRate: 'کرتە بکە بۆ هەڵسەنگاندنی ئەم کتێبە',
    loginRequired: 'تکایە بڕۆ ژوورەوە بۆ پێداچوونەوەی ئەم کتێبە',
    views: 'بینین',
    downloads: 'داگرتن',
    likes: 'لایکەکان',
    readPdf: 'خوێندنەوە',
    listenBook: 'گوێگرتن',
    chapter: 'بەشی',
    download: 'داگرتن',
    buyNow: 'ئێستا بیکڕە',
    bookNotFound: 'کتێبەکە نەدۆزرایەوە',
    description: 'دەربارەی کتێب',
    author: 'نووسەر',
    category: 'بەش',
    subtitle: 'ناونیشان',
    reviews: 'پێداچوونەوەکان',
    review: 'پێداچوون',
    writeReview: 'پێداجوونەوەت بۆ ئەم کتێبە بنووسە',
    submitReview: 'بنێرە',
    reviewSubmitted: 'پێداچوونەوەکەت زیادکرا',
    reviewRequired: 'پێداچوونەوە نیە',
    reviewSubmissionError: 'پێداچوونەوەکە نەنێردرا. تکایە دووبارە هەوڵ بدەرەوە',
    rating: 'هەڵسەنگاندن',
    reviewer: 'پێداچووندەر',
    comment: 'پێداچوون',
    createdAt: 'دروستکراوە لە',
    noReviews: 'هیچ پێداچوونەوە نیە',
    noBiography: 'دەربارەی نووسەر نەدۆزراوە',
    noDateOfBirth: 'بەرواری لە دایک بوون نەدۆزراوە',
    join: 'هەژمار دروست بکە',
    signin: 'چوونە ژوورەوە',
    menuLanguage: 'کوردی',
    menuBrowse: 'بژارکردن',
    menuProfile: 'پرۆفایل',
    menuAuthors: 'نووسەرەکان',
    menuMyBooks: 'کتێبەکانم',
    menuSettings: 'دەستکاری',
    menuSignOut: 'چوونە دەرەوە',
    searchBooks: 'گەڕان بە دوای کتێب',
    searchAuthors: 'گەڕان بە دوای نووسەر',
    noBooksAvailable: 'هیچ کتێبەک نەدۆزراوە',
    followAuthor: 'نووسەر فۆڵۆو بکە',
    latestBooks: 'نوێترین کتێبەکانی نووسەر',
    noAuthorsAvailable: 'هیچ نووسەرەک نەدۆزراوە',
    book: 'کتێب',
    books: 'کتێب',
    moreBooks: 'کتێبی تر',
    signinWithGoogle: 'چوونە ژوورەوە بە گوگل',
    newToKtebstan: 'تازەی بۆ کتێبستان؟',
    createAnAccount: 'هەژمار دروست بکە',
    alreadyHaveAnAccount: 'هەژماری بەدەست دەبێت؟',
    signupWithGoogle: 'بە گوگل هەژمار دروست بکە',
    name: 'ناو',
    email: 'ئیمەیل',
    password: 'وشەی نهێنی',
    confirmPassword: 'وشەی نهێنییەکە بەراوەرەوە',
    bookStatistics: 'ئاماری کتێبەکان',
    totalBooks: 'کۆی کتێبەکان',
    byDownloads: 'بەپێی داگرتن',
    byViews: 'بەپێی بینین',
    byTitle: 'بەپێی ناو',
    byLikes: 'بەپێی لایک',
    sort: 'ڕیزکردن',
    pdfNotAvailable: 'فایلی خوێندنەوەی کتێب نەدۆزراوە',
    bookAudioFileNotAvailable: 'فایلی گوێگرتنی کتێب نەدۆزراوە',
    allRightsReserved: 'مافی پارێزراوە',
    contactUs: 'پەیوەندی بکە',
    termsOfService: 'مەرجەکانی بەکارهێنان',
    privacyPolicy: 'پاراستنی زانیاری',
    notice: 'ڕوونکردنەوەیەکی گرنگ: تکایە ئاگاداربن کە کێبستان هیچ کتێبێک سکان ناکات. هەموو ئەو کتێب و بەڵگەنامانەی لەم کتێبخانەیەدا هەن، یان لەلایەن خاوەنەکانیانەوە پێشکەش کراون، یان لەلایەن کەس و دەزگای دیکەوە دیجیتاڵ کراون. ئەگەر پێویست بوو کتێبێک لابردرێت لەم وێبسایتە تکایە پەیوەندیمان پێوە بکەن. سوپاس بۆ تێگەیشتنتان.',
    page: 'لاپەڕە',
    next: 'دواتر',
    previous: 'پێشتر',
    speed: 'خێرایی',
    cancel: 'داخستن',
    submit: 'بنێرە',
    friends: 'هاوڕێ',
    noFriends: 'هیچ هاوڕێی نییە',
    recentActivity: 'چالاکییەکان',
    noRecentActivity: 'هیچ چالاکییەک نییە',
    followers: 'فۆڵۆوەران',
    avgRating: 'هەڵسەنگاندن',
    booksRead: 'کتێبی خوێندووەتەوە',
    booksWishlist: 'کتێبی خوازراو',
    joined: 'بەرواری بەشداربوون',
    location: 'شوێن',
    userNotFound: 'ئەم بەکارهێنەرە نەدۆزراوە',
    loading: 'چاوەڕوان بە...',
    noSocialLinks: 'هیچ لینکی سۆشیالی نییە',
    underConstruction: 'لە پەرەپێدانە',
    profileUpdateSuccess: "پرۆفایلت بە سەرکەوتوویی چاککرا",
    profileUpdateError: "نەتوانرا پرۆفایلت چاک بکرێت",
    unauthorized: "پێویستە هەژمار درووست بکەیت",
    uploadPhoto: "وێنەت زیاد بکە",
    phone: "ژمارەی مۆبایل",
    saving: "پاشەکەوتکردن...",
    saveChanges: "بنێرە",
    editProfile: "چاک کردنی پرۆفایل",
    addFriend: "هاوڕێ زیاد بکە",
    friendRequestSent: "داواکاری هاوڕێیەتی نێردرا",
    following: "فۆڵۆوەر",
    follow: "فۆڵۆو بکە",
    message: "پەیام بنێرە",
    friendRequest: "داواکاری هاوڕێیەتی",
    paidBookAudioMessage: "ئەم کتێبە دەنگیەە تەنها لە ئاپی مۆبایلی کتێبستان بەردەستە"
  }
} as const;

export type Language = keyof typeof translations;
export type TranslationKey = keyof typeof translations.en; 